'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRespondersNameText = undefined;

var _responderGetters = require('conversations-schema/responders/operators/responderGetters');

var getRespondersNameText = exports.getRespondersNameText = function getRespondersNameText(responders) {
  return responders.map(function (responder) {
    return (0, _responderGetters.getFriendlyOrFormalName)(responder) || (0, _responderGetters.getEmail)(responder);
  }).join(', ');
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-internal-components/static-1.4266/js/visitor-widget/operators/getRespondersNameText.js
// module id = 1054
// module chunks = 2 3